<template>
  <div class="device-container d-flex flex-column mb-3">
    <!-- <div
      class="device-top"
      :class="[device.status === 'good' ? 'stable' : 'critical']"
    ></div> -->
    <div class="d-flex h-100 p-3">
      <div class="d-flex align-items-center mr-3 ">
        <div
          class="checkbox-box"
          :class="{ checked: checked }"
          @click="checkDevice"
        >
          <img v-if="checked" src="../assets/images/checkbox.svg" alt="" />
        </div>
      </div>
      <div class="d-flex justify-content-center flex-column">
        <h2 v-if="device.settings" class="mb-2 font-16 font-semibold">
          {{ device.settings.name }}
        </h2>
        <p class="mb-2 font-14 gray4">{{ device.deviceTag }}</p>
        <div class="gray4">
          <p v-if="device.stat && device.stat.deviceTimeStamp" class="mb-0">
            {{ getDate(device.stat.deviceTimeStamp) }}
          </p>
          <p v-else>{{ $t("no_read") }}</p>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <div
          v-if="device.stat && device.stat.temperature"
          class="device-card-svg mr-1 d-flex"
        >
          <div>
            <IconTemp />
          </div>
          <div>{{ device.stat.temperature }}°C</div>
        </div>
        <div
          v-if="device.type === 'mote' && device.stat && device.stat.humidity"
          class="device-card-svg d-flex"
        >
          <div>
            <IconHumi />
          </div>
          <div>{{ device.stats.humidity }}%</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconTemp from "./Iconsvg/IconTemp";
import IconHumi from "./Iconsvg/IconHumi";
import moment from "moment";

export default {
  name: "DeviceCard",
  components: {
    IconTemp,
    IconHumi,
  },
  props: {
    device: Object,
    selectAll: Boolean,
  },
  data() {
    return {
      checked: true,
      inFocus: false,
    };
  },
  watch: {
    selectAll: {
      handler: function() {
        if (this.selectAll) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    checkDevice() {
      this.checked = !this.checked;
      if (!this.device?.stat.longitude || !this.device.stat?.latitude) return;
      this.$emit("check-device", {
        device: this.device,
        checked: this.checked,
      });
    },
    getDate(date) {
      return moment(date).format("MM/DD/YYYY hh:mmA");
    },
  },
};
</script>

<style>
.device-card-svg svg {
  width: 20px;
  height: 16px;
}
</style>

<style scoped>
.device-top {
  height: 3px;
  border-radius: 5px 5px 0px 0px;
}
.critical {
  background: #eb5757;
}
.stable {
  background: #213e7a;
}
.device-container {
  /* height: 108px; */
  /* border-bottom: ; */
  box-shadow: 0px 1px 0px #e1e7ec;
}
/* .icon-box {
  height: 30px;
  width: 30px;
  border: 1px solid;
  border-radius: 5px;
} */
.checkbox-box {
  height: 14px;
  width: 14px;
  border: 0.5px solid rgba(34, 34, 34, 0.9);
  box-sizing: border-box;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
} /* background: #404a57; */
</style>
<i18n>
{
	"en": {
		"google_map": "",
		"last_seen": "Last seen",
		"no_read": "Last seen: No readings yet",
		"open_str": ""
	},
	"es": {
		"google_map": "",
		"last_seen": "Ultima vez visto",
		"no_read": "Visto por última vez: No hay lecturas todavía",
		"open_str": ""
	},
	"fr": {
		"google_map": "",
		"last_seen": "Vu pour la dernière fois",
		"no_read": "Vu pour la dernière fois : aucune lecture pour le moment",
		"open_str": ""
	},
	"sw": {
		"google_map": "",
		"last_seen": "Mara ya mwisho kuonekana",
		"no_read": "Mara ya mwisho kuonekana: Bado hakuna masomo",
		"open_str": ""
	}
}
</i18n>
